export default __webpack_public_path__ + "static/media/template9.4313de18.svg";